module.exports = __webpack_public_path__ + "assets-cabinet/img/cz.475eac6c.svg";